import styled from 'styled-components';

export const StyledGameTablesContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    padding: 0 10%;
    
    &>div {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 20px;
    }

    @media (max-width: 1300px) {
        padding: 0 5%;
    }
`